// antd design tokens. Colour values mirror the CSS variables in app.scss.
const theme = {
  token: {
    colorPrimary: "#c44a0a",
    colorLink: "#c44a0a",
    colorSuccess: "#2e7556",
    colorError: "#c0362c",
    colorText: "#18202b",
    colorTextSecondary: "#5b6472",
    colorBorder: "#cfd4dc",
    colorBorderSecondary: "#e4e7ec",
    colorBgLayout: "#f5f6f8",
    borderRadius: 8,
    borderRadiusLG: 12,
    controlHeight: 36,
    fontSize: 14,
    fontFamily:
      '"IBM Plex Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  },
};

export default theme;
